import { Input, LearnMoreLink, Text } from '@ui/themed';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useSettings, useUpdateSettings } from '../../../context/settings-context';
import { DOCS_URLS, I18N_PAGE } from '../constants';

const PREFIX_KEY = 'internalVisiblePurchaseIdPrefix';
const POSTFIX_KEY = 'internalVisiblePurchaseIdPostfix';

// Saves on blur rather than per keystroke, and re-seeds when settings change underneath.
export function PurchaseIdAffixesRow() {
  const settings = useSettings();
  const { mutate } = useUpdateSettings();

  const [prefix, setPrefix] = useState(settings[PREFIX_KEY] ?? '');
  const [postfix, setPostfix] = useState(settings[POSTFIX_KEY] ?? '');

  useEffect(() => {
    setPrefix(settings[PREFIX_KEY] ?? '');
    setPostfix(settings[POSTFIX_KEY] ?? '');
  }, [settings[PREFIX_KEY], settings[POSTFIX_KEY]]);

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex min-w-0 flex-1 flex-col">
        <Text>{t(`${I18N_PAGE}.cards.other_configurations.fields.purchase_id_affixes.label`)}</Text>
        <Text size="sm" variant="secondary">
          {t(`${I18N_PAGE}.cards.other_configurations.fields.purchase_id_affixes.description`)}{' '}
          <LearnMoreLink link={DOCS_URLS.applyPriceBreaksAcrossVariants} />
        </Text>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <Input
          short
          value={prefix}
          placeholder={t(
            `${I18N_PAGE}.cards.other_configurations.fields.purchase_id_affixes.placeholder`,
          )}
          onChange={setPrefix}
          onBlur={() => {
            if (prefix !== (settings[PREFIX_KEY] ?? '')) {
              mutate({ key: PREFIX_KEY, value: prefix });
            }
          }}
        />
        <span className="shrink-0 text-gray-500 text-sm">1000</span>
        <Input
          short
          value={postfix}
          placeholder={t(
            `${I18N_PAGE}.cards.other_configurations.fields.purchase_id_affixes.placeholder`,
          )}
          onChange={setPostfix}
          onBlur={() => {
            if (postfix !== (settings[POSTFIX_KEY] ?? '')) {
              mutate({ key: POSTFIX_KEY, value: postfix });
            }
          }}
        />
      </div>
    </div>
  );
}
